import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import ClientList from "src/components/CSO/Client/Client-list";

// ----------------------------------------------------------------------

export default function CSOClients() {
  return (
    <>
      <Helmet>
        <title> Clients </title>
      </Helmet>

      <Container maxWidth="xl">
        <ClientList />
      </Container>
    </>
  );
}
